import React from 'react';

import { FactionInfo } from '../../../constants/EntertainmentGames/gameFaction';
import {
  getBoardTypeByItemId,
  SinglePieceChessBoardType,
} from '../../../constants/EntertainmentGames/singlePieceChessBoard';
import { Images } from '../../../constants/images';
import { SVGIconType } from '../../../constants/svgIcon';
import {
  BoardDesign,
  PieceDesigns,
} from '../../../models/SpaceStore/MultiplayerGame';
import { useFileStore } from '../../../stores/FileStore';
import { ChessPieceLayoutGroup } from '../ChessPieceLayoutGroup';
import { SingleChessBoardView } from '../SingleChessBoardView';
import { SvgIcon } from '../SVGIcon';

type SpeakingContentViewProps = {
  width?: number;
  height?: number;
  backgroundImageSource: string | undefined;
  board?: {
    boardDesign: BoardDesign;
    boardSize: number;
  };

  chessLayout?: {
    pieceSteps: {
      x: number;
      y: number;
    }[];
    pieceDesigns: PieceDesigns;
    iconImageSource: string | undefined;
    faction: FactionInfo | undefined;
  };
  bubbleFrameShape?: 'circle' | 'rounded';
  frameColor?: string;
};

export const SpeakingContentView = (props: SpeakingContentViewProps) => {
  const screenWidth = window.innerWidth;
  const {
    width = screenWidth < 450 ? screenWidth * 0.8 : 400,
    height = screenWidth < 450 ? screenWidth * 0.8 : 400,
    backgroundImageSource,
    board,
    chessLayout,
    bubbleFrameShape = 'circle',
    frameColor = '#EE8C8D',
  } = props;

  const boardType = board?.boardDesign.itemId
    ? getBoardTypeByItemId(board?.boardDesign.itemId)
    : undefined;

  const boardImageSource =
    board?.boardDesign.image?.fileId &&
    useFileStore.getState().getFileUrl(board?.boardDesign.image?.fileId);

  const centerStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: `80%`,
    height: `80%`,
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      {/* // <div style={{ width, height, position: 'relative' }}> */}
      {bubbleFrameShape == 'circle' ? (
        <SvgIcon
          name={SVGIconType.BubbleShape}
          color={frameColor}
          style={{ position: 'absolute', width: '100%', height: '100%' }}
        />
      ) : (
        <SvgIcon
          name={SVGIconType.BubbleShapeShow}
          color={frameColor}
          style={{ position: 'absolute', width: '100%', height: '100%' }}
        />
      )}
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          clipPath:
            bubbleFrameShape == 'circle'
              ? 'circle(46.5% at 50% 50%)'
              : 'inset(4% round 36%)',
        }}
      >
        <img
          src={backgroundImageSource ?? Images.speakingGameBackground}
          alt="Background"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            zIndex: 0,
          }}
        />
        {board ? (
          <>
            <div style={{ ...centerStyle, opacity: 1 }}>
              <SingleChessBoardView
                boardImageSource={boardImageSource}
                boardType={boardType ?? SinglePieceChessBoardType.Board01}
                width={width * 0.8}
                height={height * 0.8}
                rows={board.boardSize ?? 7}
                columns={board.boardSize ?? 7}
              />
            </div>
          </>
        ) : null}

        {board && chessLayout ? (
          <div
            style={{
              ...centerStyle,
              width: '90%',
              // maxWidth: '600px',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '0 auto',
            }}
          >
            <ChessPieceLayoutGroup
              size={board.boardSize ?? 7}
              pieces={chessLayout.pieceSteps}
              pieceDesigns={chessLayout.pieceDesigns}
              iconImageSource={chessLayout.iconImageSource}
              faction={chessLayout.faction}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
